import { render } from "./AdvantagesSection.vue?vue&type=template&id=d3103198&ts=true"
import script from "./AdvantagesSection.vue?vue&type=script&lang=ts"
export * from "./AdvantagesSection.vue?vue&type=script&lang=ts"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__